import React from 'react';
import { Icon } from '@iconify/react';

interface ImageModalProps {
    imageSrc: string;
    altText: string;
    onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ imageSrc, altText, onClose }) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in"
            onClick={onClose}
        >
            <div
                className="relative max-w-4xl max-h-[90vh] w-full flex items-center justify-center"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute -top-12 right-0 text-white hover:text-mauve-light transition-colors"
                    aria-label="Close preview"
                >
                    <Icon icon="lucide:x" width="32" />
                </button>
                <img
                    src={imageSrc}
                    alt={altText}
                    className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
                />
            </div>
        </div>
    );
};

export default ImageModal;
